import { render, staticRenderFns } from "./MessageRemoji.vue?vue&type=template&id=e0e0bdc6&"
import script from "./MessageRemoji.vue?vue&type=script&lang=js&"
export * from "./MessageRemoji.vue?vue&type=script&lang=js&"
import style0 from "./MessageRemoji.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports